import React, { useState, useRef, useEffect } from "react";

function ProjectCard({ videoSrc, title, websiteUrl, description, techStack, bulletPoints }) {
    const [showModal, setShowModal] = useState(false);

    const handleClick = () => {
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    useEffect(() => {
        if (showModal) {
            document.documentElement.style.overflowY = 'hidden';
            document.body.style.overflowY = 'hidden';
        }

        return () => {
            document.documentElement.style.overflowY = 'auto';
            document.body.style.overflowY = 'auto';
        };
    }, [showModal]);

    return (
        <>
            <div
                className="project-card d-flex flex-column"
                onClick={handleClick}
            >
                <h3>{title}</h3>
                <video src={videoSrc} muted autoPlay playsInline loop />
            </div>
            {showModal && (
                <div className="project-modal" onClick={handleModalClose}>
                    <div className="project-modal-content p-3 pd-md-0 d-flex flex-column flex-md-row" onClick={e => e.stopPropagation()}>
                        <iframe
                            src={websiteUrl}
                            title={title}
                            className="d-none d-md-block"
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                                background: "#fff",
                                borderRadius: "24px",
                                boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px"
                            }}
                            allowFullScreen
                        />
                        <div className="project-details-container">
                            <h2>{title}</h2>
                            <div className="the-stack d-flex flex-row"> 
                                {techStack?.map((item, index) => (
                                    <div key={index} className="the-stack-item">{item}</div>
                                ))}
                            </div>
                            <p className="mb-4 project-description">{description}</p>
                            <div className="bullet-points">
                                <ul>
                                {bulletPoints?.map((point, index) => (
                                    <li key={index} className="font-weight-bold">{point}</li>
                                ))}
                                </ul>
                            </div>
                            <div className="d-none d-md-block">
                                <a href={websiteUrl} target="_blank" rel="noopener noreferrer" className="w-100 btn">
                                    Go to Site
                                </a>
                            </div>
                        </div>
                        <div className="d-block d-md-none">
                            <a href={websiteUrl} target="_blank" rel="noopener noreferrer" className="w-100 btn">
                                View Live Project
                            </a>
                        </div>
                        <button className="modal-close" onClick={handleModalClose}>×</button>
                    </div>
                </div>
            )}
        </>
    );
}

export default ProjectCard;